import React from 'react';
// import useGTMIntegrationWithConfig from '../../hooks/script-integrations/useGTMIntegrationWithConfig';
// import useGAIntegrationWithConfig from '../../hooks/script-integrations/useGAIntegrationWithConfig';
// import useCelloIntegrationWithConfig from '../../hooks/script-integrations/useCelloIntegration';
import { ThirdPartyIntegrationsProps } from './type';
import useChurnKeyIntegrationWithConfig from '../hooks/script-integrations/useChurnKeyIntegrationWithConfig';
import useGleapsIntegrationWithConfig from '../hooks/script-integrations/useGleapsIntegrationWithConfig';
import usePaddleIntegrationWithConfig from '../hooks/script-integrations/usePaddleIntegrationWithConfig';
import useHighAdvocacyIntegrationWithConfig from '../hooks/script-integrations/useHighAdvocacyIntegrationWithConfig';
import useGleapUserIdentityWithConfig from '../hooks/script-integrations/useGleapUserIdentityWithConfig';
import usePosthogIntegrationWithConfig from '../hooks/script-integrations/usePosthogIntegrationWithConfig';
import useBetterBugsIntegrationWithConfig from '../hooks/script-integrations/useBetterBugsIntegrationWithConfig';
import useCustomerioIntegrationWithConfig from '../hooks/script-integrations/useCustomerioIntegrationWithConfig';

const ThirdPartyIntegrations: React.FC<ThirdPartyIntegrationsProps> = ({
  enableChurnKey = true,
  enableGleaps = true,
  enablePaddle = true,
  enableHighAdvocacy = true,
  enablePosthog = true,
  enableBetterBugs = true,
  enableCustomerio = true,
  onChurnKeyError = () => {},
  onGleapsError = () => {},
  onPaddleError = () => {},
  onHighAdvocacyError = () => {},
  onCustomerioError = () => {},
}) => {
  // For Gleaps integration
  useGleapsIntegrationWithConfig({
    enable: enableGleaps,
    onError: onGleapsError,
  });

  // For ChurnKey integration
  useChurnKeyIntegrationWithConfig({
    enable: enableChurnKey,
    onError: onChurnKeyError,
  });

  // For Paddle integration
  usePaddleIntegrationWithConfig({
    enable: enablePaddle,
    onError: onPaddleError,
  });

  // For HighAdvocacy integration
  useHighAdvocacyIntegrationWithConfig({
    enable: enableHighAdvocacy,
    onError: onHighAdvocacyError,
  });

  // For PostHog integration
  usePosthogIntegrationWithConfig({
    enable: enablePosthog,
  });

  useGleapUserIdentityWithConfig({
    enable: enableGleaps,
  });

  useBetterBugsIntegrationWithConfig({
    enable: enableBetterBugs,
  });

  // For Customer.io integration
  useCustomerioIntegrationWithConfig({
    enable: enableCustomerio,
    onError: onCustomerioError,
  });

  return null;
};

export default ThirdPartyIntegrations;
